type FreestarPLShortPlacementId =
  | 'incontent_reusable'
  | 'leaderboard_atf'
  | 'incontent_728_reusable'
  | 'incontent_970_reusable'
  | 'incontent_300x250_reusable';

export type FreestarPLPlacementId =
  | 'pickleballleagues-com_incontent_reusable'
  | 'pickleballleagues-com_leaderboard_atf'
  | 'pickleballleagues-com_incontent_728_reusable'
  | 'pickleballleagues-com_incontent_970_reusable'
  | 'pickleballleagues-com_incontent_300x250_reusable';

export const PLACEMENT_IDS_PL: Record<FreestarPLShortPlacementId, FreestarPLPlacementId> = {
  incontent_reusable: 'pickleballleagues-com_incontent_reusable',
  leaderboard_atf: 'pickleballleagues-com_leaderboard_atf',
  incontent_728_reusable: 'pickleballleagues-com_incontent_728_reusable',
  incontent_970_reusable: 'pickleballleagues-com_incontent_970_reusable',
  incontent_300x250_reusable: 'pickleballleagues-com_incontent_300x250_reusable',
};
